import {useNavigate} from "react-router-dom"
import {useTranslation} from "react-i18next"
import {useMutation, useSuspenseQuery} from "@tanstack/react-query"
import {useAnalytics} from "@indebted/analytics"
import {paymentArrangementAPI} from "@indebted/api/paymentArrangementAPI"
import {useNotification} from "@indebted/components/Notification"
import {ApiError} from "@indebted/api/ApiError"

import {useCustomerInfoQuery} from "../../src/useCustomerInfo"

import {nextPage} from "./Navigator"

export function usePaymentArrangementInitiateSetup() {
	const {track} = useAnalytics()
	const navigate = useNavigate()
	const {notification} = useNotification()
	const {t} = useTranslation()

	const {data: customerInfo} = useSuspenseQuery(useCustomerInfoQuery())
	const secureCode = customerInfo.SecureCode

	return useMutation({
		mutationFn: () => paymentArrangementAPI.initiateSetup({secureCode}),
		onMutate: () => {
			track("PaymentArrangementInitiateSetup", {
				SecureCode: secureCode,
			})
		},
		onSuccess: (data) => {
			track("PaymentArrangementInitiateSetupSucceeded", {
				SecureCode: secureCode,
			})

			navigate(nextPage(data.Next, data.PaymentArrangementID))
		},
		onError: (error) => {
			track("PaymentArrangementInitiateSetupFailed", {
				SecureCode: secureCode,
			})

			if (error instanceof ApiError) {
				notification.error(error.Message, 5000)
			} else {
				notification.error(t("unexpected_error.message"), 5000)
			}

			console.error(error)
		},
	})
}

export function usePaymentArrangementInitiateInFullSetup() {
	const {track} = useAnalytics()
	const navigate = useNavigate()
	const {notification} = useNotification()
	const {t} = useTranslation()

	const {data: customerInfo} = useSuspenseQuery(useCustomerInfoQuery())
	const secureCode = customerInfo.SecureCode

	return useMutation({
		mutationFn: async () => {
			const response = await paymentArrangementAPI.initiateSetup({secureCode})
			const setupResponse = await paymentArrangementAPI.postSetup({
				paymentArrangementID: response.PaymentArrangementID,
				frequency: "Fortnightly",
				startDate: new Date(),
				numberOfPayments: 1,
			})
			return {Next: setupResponse.Next, PaymentArrangementID: response.PaymentArrangementID}
		},
		onMutate: () => {
			track("PaymentArrangementInitiateSetup", {
				SecureCode: secureCode,
			})
		},
		onSuccess: (data) => {
			track("PaymentArrangementInitiateSetupSucceeded", {
				SecureCode: secureCode,
			})

			navigate(nextPage("payment-in-full", data.PaymentArrangementID))
		},
		onError: (error) => {
			track("PaymentArrangementInitiateSetupFailed", {
				SecureCode: secureCode,
			})

			if (error instanceof ApiError) {
				notification.error(error.Message, 5000)
			} else {
				notification.error(t("unexpected_error.message"), 5000)
			}

			console.error(error)
		},
	})
}
